import React from 'react';
import { ScreenController, useFaContent } from 'src/feature-app';
import { CemController, LEMController, NoCompraController, NoRenovacionController } from 'src/forms';
import { CEMOneShopController } from "src/forms/Cem/CEM OneShop";

export function EncuestasTrigger() {
  const faContent = useFaContent();

  const renderTrigger = (Controller: JSX.Element) => {
    return (
      <>
        <ScreenController
          selectedJourney={Controller}
          closeLayerCallback={close}
          handleAreYouSureLayer={() => null}
          formType = 'inPage'
        />
      </>
    );
  };

  switch (faContent?.encuesta) {
    case 'CEM - POSVENTA':
    case 'CEM - VENTA':
      return renderTrigger(<CemController />);
    case 'CEM - ONESHOP':
      return renderTrigger(<CEMOneShopController />);
    case 'LEM':
      return renderTrigger(<LEMController />);
    case 'NO COMPRA':
      return renderTrigger(<NoCompraController />);
    case 'NO RENOVACIÓN':
      return renderTrigger(<NoRenovacionController />);

    default:
      throw new Error('No property encuesta in FA Content.');
  }
}
